// @ts-nocheck
import React from 'react'
import { jt, t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Arrow } from 'components/shared/Arrow/Arrow'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'

import styles from './LockMessage.module.scss'

export const LockMessage = ({
  arrowRef,
  arrowStyle,
  floating,
  floatingStyle,
  owner,
  hasArrow,
  isToggled,
}) => {
  const creator = <strong key="owner">{owner}</strong>

  return (
    <TetherPortal isOpen={isToggled}>
      <Box
        align="center"
        className={styles.message}
        justify="center"
        ref={floating}
        role="status"
        style={floatingStyle}
      >
        {hasArrow ? (
          <Arrow ref={arrowRef} size="small" style={arrowStyle} theme="dark" />
        ) : null}
        <Box
          align="center"
          className={styles.content}
          direction="column"
          justify="center"
          role="tooltip"
        >
          <h3 className={styles.title}>{t`Action disabled`}</h3>
          <p className={styles.text}>
            {jt`This position was created from ${creator}.`}
          </p>
          <p className={styles.text}>
            {t`Some actions are therefore not available in the Ebber Dashboard.`}
          </p>
        </Box>
      </Box>
    </TetherPortal>
  )
}
